<!-- <h1><ng-content select="[title]"></ng-content></h1> -->

<div class="card bg-white text-dark">
  <img src="/assets/img/homepage-header.jpg" class="card-img" alt="...">
  <div class="card-img-overlay-front">
    <h3 class="card-title">Welcome to Päikese Pizza!</h3>
    <p class="card-text">Where every bite is sunny and delicious!</p>
  </div>
</div>